import { Component } from '../core/component';

export class Logo extends Component {
    constructor() {
        super();
        this.selector = '[data-invertlogo]';
    }

    init() {
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('has-inverted-logo');
    }
}
